import React from 'react';
interface Props {
  fillColor?: string;
}
function EyeTherapyIcon({ fillColor = '#17385D' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none">
      <g clipPath="url(#clip0_851_3607)">
        <path
          d="M8.99922 2.89453C6.96172 2.89453 5.28672 3.81953 4.00234 5.01016C2.79922 6.12891 1.96797 7.45703 1.54297 8.39453C1.96797 9.33203 2.79922 10.6602 3.99922 11.7789C5.28672 12.9695 6.96172 13.8945 8.99922 13.8945C11.0367 13.8945 12.7117 12.9695 13.9961 11.7789C15.1992 10.6602 16.0305 9.33203 16.4555 8.39453C16.0305 7.45703 15.1992 6.12891 13.9992 5.01016C12.7117 3.81953 11.0367 2.89453 8.99922 2.89453ZM2.98047 3.91328C4.45234 2.54453 6.47422 1.39453 8.99922 1.39453C11.5242 1.39453 13.5461 2.54453 15.018 3.91328C16.4805 5.27266 17.4586 6.89453 17.9242 8.01016C18.0273 8.25703 18.0273 8.53203 17.9242 8.77891C17.4586 9.89453 16.4805 11.5195 15.018 12.8758C13.5461 14.2445 11.5242 15.3945 8.99922 15.3945C6.47422 15.3945 4.45234 14.2445 2.98047 12.8758C1.51797 11.5195 0.539844 9.89453 0.0773437 8.77891C-0.0257813 8.53203 -0.0257813 8.25703 0.0773437 8.01016C0.539844 6.89453 1.51797 5.26953 2.98047 3.91328ZM8.99922 10.8945C10.3805 10.8945 11.4992 9.77578 11.4992 8.39453C11.4992 7.01328 10.3805 5.89453 8.99922 5.89453C8.97734 5.89453 8.95859 5.89453 8.93672 5.89453C8.97734 6.05391 8.99922 6.22266 8.99922 6.39453C8.99922 7.49766 8.10234 8.39453 6.99922 8.39453C6.82734 8.39453 6.65859 8.37266 6.49922 8.33203C6.49922 8.35391 6.49922 8.37266 6.49922 8.39453C6.49922 9.77578 7.61797 10.8945 8.99922 10.8945ZM8.99922 4.39453C10.0601 4.39453 11.0775 4.81596 11.8276 5.5661C12.5778 6.31625 12.9992 7.33367 12.9992 8.39453C12.9992 9.4554 12.5778 10.4728 11.8276 11.223C11.0775 11.9731 10.0601 12.3945 8.99922 12.3945C7.93835 12.3945 6.92094 11.9731 6.17079 11.223C5.42065 10.4728 4.99922 9.4554 4.99922 8.39453C4.99922 7.33367 5.42065 6.31625 6.17079 5.5661C6.92094 4.81596 7.93835 4.39453 8.99922 4.39453Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_851_3607">
          <rect
            width="18"
            height="16"
            fill="white"
            transform="translate(0 0.394531)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default EyeTherapyIcon;
